import Footer from '../../components/General/Footer';
import Head from '../../components/Header/Head';
import Header from '../../components/Header/Header';
import withApollo from '../../lib/withApollo';
import BlogNameGenerator from 'components/Tools/BlogNameGenerator/BlogNameGenerator';

function TravelBlogNameGeneratorPage() {
  return (
    <>
      <Head
        shorttitle="Free Travel Blog Name Ideas Generator"
        description="Generate travel blog name ideas from your keywords, browse 100+ curated names by niche, and check domain and username availability in one click."
        image={`${process.env.NEXT_PUBLIC_ROOTURL}/img/travel-blog-name-ideas-generator-og.png`}
        seo={{
          canonicalUrl:
            'https://travelfeed.com/tools/travel-blog-name-ideas-generator',
        }}
      />
      <Header
        active="travel-blog-name-ideas-generator"
        subheader="Travel Blog Name Ideas Generator"
      />
      <BlogNameGenerator />
      <div style={{ backgroundColor: '#00695C' }}>
        <Footer isLightFont isNoSpace />
      </div>
    </>
  );
}

export default withApollo(TravelBlogNameGeneratorPage);
